import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './MicroneedlingBioRePeel.css';

function MicroneedlingBioRePeel() {
  const { t } = useTranslation();

  return (
    <div className="microneedling-biorepeel-page">
      {/* Hero Section */}
      <section className="microneedling-biorepeel-hero">
        <div className="container">
          <h1>Microneedling + BioRePeel</h1>
          <p className="hero-subtitle">
            Advanced Collagen Induction + Chemical Biostimulation
          </p>
          <p className="hero-description">
            This combination treatment delivers a powerful dual approach to skin rejuvenation. Microneedling stimulates 
            collagen and elastin production at a deeper level, while BioRePeel works on the surface and mid-dermis to 
            refine texture, address pigmentation, and enhance cellular renewal.
          </p>
          <p className="hero-note">
            Together, they significantly improve skin clarity, firmness, and radiance with minimal downtime.
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="microneedling-biorepeel-content">
        <div className="container">
          <div className="content-wrapper">
            {/* Treatment Summary */}
            <div className="content-section">
              <h2>Treatment Summary</h2>
              <ul className="summary-list">
                <li>Procedure time: 45–60 minutes</li>
                <li>Full recovery: mild redness for 24–48 hours</li>
                <li>Anaesthetic: numbing cream available if required</li>
                <li>Possible side effects: temporary redness, mild swelling, sensitivity; less common – bruising or temporary pigmentation changes</li>
              </ul>
            </div>

            {/* What This Treatment Improves */}
            <div className="content-section">
              <h2>What This Treatment Improves</h2>
              <ul className="benefits-list">
                <li>Acne scars and post-inflammatory marks</li>
                <li>Fine lines and early ageing concerns</li>
                <li>Pigmentation and uneven skin tone</li>
                <li>Enlarged pores and surface irregularities</li>
                <li>Dull, congested, or dehydrated skin</li>
                <li>Textural issues related to acne</li>
              </ul>
              <div className="highlight-note">
                <p>
                  <strong>Optimal for clients seeking stronger clinical results and visible transformation.</strong>
                </p>
              </div>
            </div>

            {/* Treatment Protocol */}
            <div className="content-section">
              <h2>Treatment Protocol</h2>
              <p>
                This enhanced session includes:
              </p>
              <ul className="protocol-list">
                <li>Deep double cleanse</li>
                <li>Enzyme exfoliation</li>
                <li>Microneedling using Dr Pen A20</li>
                <li>BioRePeel application for targeted biostimulation</li>
                <li>Healing support mask</li>
                <li>Barrier repair moisturiser and high-protection SPF</li>
              </ul>
            </div>

            {/* Key Benefits */}
            <div className="content-section">
              <h2>Key Benefits of the Combination</h2>
              <ul className="key-benefits-list">
                <li>Strong collagen induction plus chemical skin renewal</li>
                <li>Increased product penetration for superior outcomes</li>
                <li>Enhanced brightness and smoother texture</li>
                <li>Natural results with low discomfort</li>
                <li>Suitable for most skin types and tones</li>
              </ul>
              <div className="reassurance-note">
                <p>
                  <em>Many clients notice visible improvement even after their first session.</em>
                </p>
              </div>
            </div>

            {/* Contraindications */}
            <div className="content-section">
              <h2>Contraindications</h2>
              <p>
                Not suitable for individuals who:
              </p>
              <ul className="contraindications-list">
                <li>Are pregnant or breastfeeding</li>
                <li>Are taking prescription acne medication (e.g., isotretinoin)</li>
                <li>Have active cold sores, acne, eczema, or infection</li>
                <li>Used retinol/AHA/BHA within the last 7 days</li>
                <li>Had Botox or fillers within the last 2 weeks</li>
                <li>Have fresh bruising or recent trauma</li>
                <li>Have uncontrolled diabetes</li>
                <li>Have scar tissue less than 6 months old</li>
                <li>Are undergoing oncology treatment</li>
              </ul>
            </div>

            {/* CTA Section */}
            <div className="cta-section">
              <h2>{t('services.cta.title')}</h2>
              <p>{t('services.cta.description')}</p>
              <div className="cta-buttons">
                <a href="https://widget.treatwell.co.uk/place/beauty-lounge-green-canning-town/" target="_blank" rel="noopener noreferrer" className="cta-button primary">{t('services.cta.button')}</a>
                <Link to="/services" className="cta-button secondary">Back to Services</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default MicroneedlingBioRePeel;

